<template>
  <div>
    <v-card>
      <v-card-title v-if="!hideSearch">
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="tableHeader" :items="tableRows" :search="search" :options.sync="options" :server-items-length="totalItens" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>{{ tableTitle }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="newRowmodalButtonText" @click="emitDataTableNewRowEvent">{{ newRowmodalButtonText }}</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.DT_ENTRADA`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.DT_ENTRADA) }}
        </template>

        <template v-slot:[`item.dataRegistro`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataRegistro) }}
        </template>

        
        <template v-if="isKit" v-slot:[`item.quantidade`]="{ item }">
          <v-chip :color="item.color" dark>{{ item.quantidade }}</v-chip>
        </template>

        <template v-slot:[`item.dataDispensaPaciente`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataDispensaPaciente) }}
        </template>

        <template v-slot:[`item.validade`]="{ item }">
          <v-chip :color="corValidade(item.validade)" dark>{{ item.validade }}</v-chip>
        </template>

        <template v-slot:[`item.validadeItem`]="{ item }">
          <v-chip :color="corValidade(item.validadeItem)" dark>{{ item.validadeItem }}</v-chip>
        </template>

        <template v-slot:[`item.item.validade`]="{ item }">
          <v-chip :color="corValidade(item.item.validade)" dark>{{ item.item.validade }}</v-chip>
        </template>

        <template v-slot:[`item.dataDispensaSetor`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataDispensaSetor) }}
        </template>

        <template v-slot:[`item.dispensaKit.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dispensaKit.dataDispensa) }}
        </template>

        <template v-slot:[`item.dispensaPaciente.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dispensaPaciente.dataDispensa) }}
        </template>

        <template v-slot:[`item.DT_DISPENSA`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.DT_DISPENSA) }}
        </template>

        
        <template v-slot:[`item.dataNascimentoPaciente`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataNascimentoPaciente) }}
        </template>
        

        <template v-slot:[`item.historicoEntrada.dataEmissao`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.historicoEntrada.dataEmissao) }}
        </template>

        <template v-slot:[`item.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataDispensa) }}
        </template>

        <template v-slot:[`item.dataDispensaSubestoque`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataDispensaSubestoque) }}
        </template>

        <template v-slot:[`item.dispensaSubestoque.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dispensaSubestoque.dataDispensa) }}
        </template>

        <template v-slot:[`item.dataNascimento`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dataNascimento) }}
        </template>

        <template v-slot:[`item.paciente.dataNascimento`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.paciente.dataNascimento) }}
        </template>

        <template v-slot:[`item.solicitarItem.dataSolicitarItem`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.solicitarItem.dataSolicitarItem) }}
        </template>

        <template v-slot:[`item.solicitacaoRegistro.dataSolicitacao`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.solicitacaoRegistro.dataSolicitacao) }}
        </template>

        <template v-slot:[`item.dispensa.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dispensa.dataDispensa) }}
        </template>

        <template v-slot:[`item.dispensaUnidade.dataDispensa`]="{ item }">
          {{ _formatStringInBrazilianDateFormat(item.dispensaUnidade.dataDispensa) }}
        </template>

        <template v-slot:[`item.indicadorStatusDispensa`]="{ item }">
          {{ formataStatusReceberItem(item.indicadorStatusDispensa) }}
        </template>

        <template v-slot:[`item.solicitarItem.indicadorTipo`]="{ item }">
          {{ formataTipoSolicitacao(item.solicitarItem.indicadorTipo) }}
        </template>

        <template v-slot:[`item.dispensaPaciente.indicadorTipoDispensa`]="{ item }">
          {{ formataTipoDispensa(item.dispensaPaciente.indicadorTipoDispensa) }}
        </template>

        <template v-slot:[`item.tipoDispensa`]="{ item }">
          {{ formataTipoDispensa(item.tipoDispensa) }}
        </template>

        <template v-slot:[`item.solicitarItem.indicadorStatusSolicitarItem`]="{ item }">
          {{ formataStatus(item.solicitarItem.indicadorStatusSolicitarItem) }}
        </template>

        <template v-slot:[`item.tipoModificacao`]="{ item }">
          {{ formataTipoModificacao(item.tipoModificacao) }}
        </template>

        <template v-slot:[`item.dispensadoParaTelaKit`]="{ item }">
          <div v-if="item.paciente.descricaoNome != null">{{ item.paciente.descricaoNome }} | {{ _formatStringInBrazilianDateFormat(item.paciente.dataNascimento) }}</div>
          <div v-else class="textovazio">N/A</div>
        </template>

        <template v-slot:[`item.nomeItemPadronizado`]="{ item }">
          <div v-if="item.nomeItemPadronizado">{{ item.nomeItemPadronizado }}</div>
          <div v-else class="textovazio">Não padronizado</div>
        </template>

        <template v-slot:[`item.quantidadeAnterior`]="{ item }">
          <div v-if="item.quantidadeAnterior != null">{{ item.quantidadeAnterior }}</div>
          <div v-else class="textovazio">Sem quantidade</div>
        </template>

        <template v-slot:[`item.quantidadePosterior`]="{ item }">
          <div v-if="item.quantidadePosterior != null">{{ item.quantidadePosterior }}</div>
          <div v-else class="textovazio">{{ item.tipoModificacao && item.tipoModificacao == 1 ? "Não Alterado" : "Sem quantidade" }}</div>
        </template>

        <template v-slot:[`item.descricaoCpf`]="{ item }">
          {{ formataVazio(item.descricaoCpf) }}
        </template>

        <template v-slot:[`item.descricaoRG`]="{ item }">
          {{ formataVazio(item.descricaoRG) }}
        </template>

        <template v-slot:[`item.descricaoNomeResponsavel`]="{ item }">
          {{ formataVazio(item.descricaoNomeResponsavel) }}
        </template>

        <template v-slot:[`item.descricaoCpfResponsavel`]="{ item }">
          {{ formataVazio(item.descricaoCpfResponsavel) }}
        </template>

        <template v-slot:[`item.descricaoDataNascimentoResponsavel`]="{ item }">
          {{ formataVazio(_formatStringInBrazilianDateFormat(item.descricaoDataNascimentoResponsavel)) }}
        </template>

        <template v-slot:[`item.observacaoSolicitarItem`]="{ item }">
          {{ formatarObservacao(item.observacaoSolicitarItem) }}
        </template>

        <template v-slot:[`item.indicadorStatusFamilia`]="{ item }">
          {{ formataFamilia(item.indicadorStatusFamilia) }}
        </template>

        <template v-slot:[`item.dispensa.indicadorStatusDispensa`]="{ item }">
          {{ formataStatusRecebimento(item.dispensa.indicadorStatusDispensa) }}
        </template>

        <template v-slot:[`item.item.indicadorStatusFamilia`]="{ item }">
          {{ formataFamilia(item.item.indicadorStatusFamilia) }}
        </template>

        <template v-slot:[`item.solicitacaoRegistro.indicadorStatus`]="{ item }">
          {{ formataStatusSolicitacaoRegistro(item.solicitacaoRegistro.indicadorStatus) }}
        </template>

        <template v-slot:[`item.dispensaKit.descricaoDispensa`]="{ item }">
          <div v-if="item.dispensaKit.descricaoDispensa">{{ item.dispensaKit.descricaoDispensa }}</div>
          <div v-else style="color: rgba(0, 0, 0, 0.3);">Não informado</div>
        </template>

        <template v-slot:[`item.paciente.descricaoNome`]="{ item }">
          <div v-if="item.paciente.descricaoNome">{{ item.paciente.descricaoNome }}</div>
          <div v-else style="color: rgba(0, 0, 0, 0.3);">Não informado</div>
        </template>

        <template v-slot:[`item.paciente.descricaoCpf`]="{ item }">
          <div v-if="item.paciente.descricaoCpf">{{ item.paciente.descricaoCpf }}</div>
          <div v-else style="color: rgba(0, 0, 0, 0.3);">Não informado</div>
        </template>

        <template v-slot:[`item.funcionario.nomeFuncionario`]="{ item }">
          <div v-if="item.funcionario.nomeFuncionario">{{ item.funcionario.nomeFuncionario }}</div>
          <div v-else style="color: rgba(0, 0, 0, 0.3);">Não informado</div>
        </template>

        <!-- <template v-if="solicitar" v-slot:[`item.solicitarItem.indicadorStatusSolicitarItem`]="{ item }">
          {{ formataStatus(item.solicitarItem.indicadorStatusSolicitarItem) }}
        </template> -->

        <template v-slot:[`item.descricaoIndicadorStatus`]="{ item }">
          <v-chip :color="getColor(item.descricaoIndicadorStatus)" dark>{{ item.descricaoIndicadorStatus }}</v-chip>
        </template>

        <template v-slot:[`item.dispensaUnidade.indicadorStatus`]="{ item }">
          <v-chip :color="formataCorStatusRecebimentoDispensa(item.dispensaUnidade.indicadorStatus)" dark>{{ formataStatusRecebimentoDispensa(item.dispensaUnidade.indicadorStatus) }}</v-chip>
        </template>

        <template v-slot:[`item.itemSistemaUnidade.indicadorStatus`]="{ item }">
          <v-chip :color="formataCorStatusItemUnidade(item.itemSistemaUnidade.indicadorStatus) + ' lighten-5'" :text-color="formataCorStatusItemUnidade(item.itemSistemaUnidade.indicadorStatus) + ' darken-2'">
            <v-icon left small>
              {{ item.itemSistemaUnidade.indicadorStatus == 1 ? "mdi-check-circle-outline" : "mdi-close-circle-outline" }}
            </v-icon>
            {{ formataStatusItemUnidade(item.itemSistemaUnidade.indicadorStatus) }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="isConfirmMaterial && item.statusMaterial === 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitMaterialRetiradoEvent(item)" v-bind="attrs" v-on="on">mdi-check-circle</v-icon>
            </template>
            <span>Confirmar Retirada de Itens</span>
          </v-tooltip>

          <v-tooltip v-if="isExcel" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitGenerateExcelEvent(item)" v-bind="attrs" v-on="on">
                mdi-microsoft-excel
              </v-icon>
            </template>
            <span>Gerar Excel</span>
          </v-tooltip>

          <v-tooltip v-if="isFinish && item.statusChamado != 0 && item.statusChamado != 8 && item.statusChamado != 7 && item.statusChamado != 3" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableFinishRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-check-circle
              </v-icon>
            </template>
            <span>Finalizar</span>
          </v-tooltip>

          <v-tooltip v-if="item.indicadorStatus != 8 && isView" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>Visualizar</span>
          </v-tooltip>

          <v-tooltip v-if="isViewDispensaUnidade" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>Visualizar</span>
          </v-tooltip>

          <v-tooltip v-if="isViewDispensaUnidade" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTablePrintEventTransferencia(item)" v-bind="attrs" v-on="on">
                mdi-printer
              </v-icon>
            </template>
            <span>Imprimir</span>
          </v-tooltip>

          <v-tooltip v-if="isViewEdit" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-eye-settings
              </v-icon>
            </template>
            <span>Visualizar/Editar</span>
          </v-tooltip>

          <v-tooltip v-if="isViewNota" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableViewRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-eye
              </v-icon>
            </template>
            <span>Visualizar</span>
          </v-tooltip>

          <v-tooltip v-if="item.indicadorStatus != 8 && isStatus" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableUpdateStatusRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Atualizar Status</span>
          </v-tooltip>

          <v-tooltip v-if="isEditStatusSolicitacao && item.solicitacaoRegistro.indicadorStatus == 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="emitDataTableUpdateStatusRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Atualizar Status</span>
          </v-tooltip>

          <div v-if="solicitar">
            <v-tooltip v-if="isPrint && item.solicitarItem.indicadorStatusSolicitarItem != 0" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" @click="emitDataTablePrintEvent(item)" v-bind="attrs" v-on="on">
                  mdi-printer
                </v-icon>
              </template>
              <span>Imprimir</span>
            </v-tooltip>

            <v-tooltip v-if="item.indicadorStatus != 8 && isEdit && item.solicitarItem.indicadorStatusSolicitarItem != 2 && item.solicitarItem.indicadorStatusSolicitarItem != 1 && item.solicitarItem.indicadorStatusSolicitarItem != 3" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" @click="emitDataTableUpdateRowEvent(item)" v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip v-if="isDel && item.solicitarItem.indicadorStatusSolicitarItem != 2 && item.solicitarItem.indicadorStatusSolicitarItem != 1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small @click="emitDataTableDeleteRowEvent(item)" v-bind="attrs" v-on="on">
                  mdi-delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </div>

          <div v-else>
            <v-tooltip v-if="isPrint" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" @click="emitDataTablePrintEvent(item)" v-bind="attrs" v-on="on">
                  mdi-printer
                </v-icon>
              </template>
              <span>Imprimir</span>
            </v-tooltip>

            <v-tooltip v-if="item.indicadorStatus != 8 && isEdit" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" @click="emitDataTableUpdateRowEvent(item)" v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip v-if="isEditDispensaUnidade && item.dispensaUnidade.indicadorStatus == 0" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="mr-2" @click="emitDataTableUpdateRowEvent(item)" v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-tooltip v-if="isDel" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small @click="emitDataTableDeleteRowEvent(item)" v-bind="attrs" v-on="on">
                  mdi-delete
                </v-icon>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </div>

          <v-tooltip v-if="isDevolucao" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableDevolucao(item)" v-bind="attrs" v-on="on">
                mdi-archive-refresh
              </v-icon>
            </template>
            <span>Devolução de Dispensa</span>
          </v-tooltip>

          <v-tooltip v-if="isDevolucaoDispensaUnidade && item.dispensaUnidade.indicadorStatus == 0" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableDevolucao(item)" v-bind="attrs" v-on="on">
                mdi-archive-refresh
              </v-icon>
            </template>
            <span>Devolução de Dispensa</span>
          </v-tooltip>

          <v-tooltip v-if="isDevolucaoProduto" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableDevolucaoProduto(item)" v-bind="attrs" v-on="on">
                mdi-refresh-circle
              </v-icon>
            </template>
            <span>Devolução de Produto</span>
          </v-tooltip>

          <v-tooltip v-if="isContext && item.indicadorStatusManutencao == 1 && item.statusChamado != 0 && item.statusChamado != 8 && item.statusChamado != 7 && item.statusChamado != 3" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small @click="emitDataTableContextRowEvent(item)" v-bind="attrs" v-on="on">
                mdi-flag-variant
              </v-icon>
            </template>
            <span>Contestar O.S</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import store from "@/store/index";

export default {
  props: {
    tableTitle: String,
    newRowmodalButtonText: String,
    hideSearch: Boolean,
    tableHeader: Array,
    tableRows: Array,
    isEdit: Boolean,
    isEditDispensaUnidade: Boolean,
    isEditStatusSolicitacao: Boolean,
    isView: Boolean,
    isViewDispensaUnidade: Boolean,
    isViewEdit: Boolean,
    isStatus: Boolean,
    isFinish: Boolean,
    isDel: Boolean,
    isDevolucao: Boolean,
    isDevolucaoDispensaUnidade: Boolean,
    isDevolucaoProduto: Boolean,
    isPrint: Boolean,
    isExcel: Boolean,
    isContext: Boolean,
    isConfirmMaterial: Boolean,
    isViewNota: Boolean,
    solicitar: Boolean,
    isKit: Boolean,
    totalItens: Number,
  },

  watch: {
    options: {
      handler() {
        this.$emit("datatable-update-page", this.options);
      },
      deep: true,
    },
    search() {
      this.$emit("datatable-update-search", this.search);
    },
  },

  data: function() {
    return {
      search: "",
      options: {
        itemsPerPage: 10,
      },
    };
  },

  methods: {
    emitPrintEvent(row) {
      this.$emit("datatable-print", row);
    },

    formatarObservacao(item) {
      if (item) {
        return item;
      } else {
        return "Sem observações";
      }
    },

    formataVazio(item) {
      if (item) {
        return item;
      } else {
        return "Não informado!";
      }
    },

    formataTipoModificacao(status) {
      switch (status) {
        case 0:
          return "Registro";
        case 1:
          return "Atualização";
        case 2:
          return "Remoção";
      }
    },

    formataStatus(status) {
      switch (status) {
        case 0:
          return "Aguardando Aprovação";
        case 1:
          return "Em processo de compras";
        case 2:
          return "Comprado";
        case 3:
          return "Recusado";
      }
    },

    formataStatusSolicitacaoRegistro(status) {
      switch (status) {
        case 0:
          return "Registro Solicitado";
        case 1:
          return "Registro Consolidado";
      }
    },

    formataTipoSolicitacao(tipo) {
      switch (tipo) {
        case 0:
          return "Solicitação Comum";
        case 1:
          return "Solicitação de Teste Rápido";
      }
    },

    formataStatusRecebimento(status) {
      switch (status) {
        case 0:
          return "Aguardando Aprovação";
        case 1:
          return "Recebido";
        case 2:
          return "Recebido com Ressalva";
        case 3:
          return "Recusado";
      }
    },

    formataStatusRecebimentoDispensa(status) {
      switch (status) {
        case 0:
          return "Aguardando Aprovação";
        case 1:
          return "Recebido";
        case 2:
          return "Recusado";
      }
    },

    formataCorStatusRecebimentoDispensa(status) {
      switch (status) {
        case 0:
          return "orange";
        case 1:
          return "green";
        case 2:
          return "red";
      }
    },

    formataStatusReceberItem(status) {
      switch (status) {
        case 0:
          return "Aguardando conferência do pedido pela Unidade";
        case 1:
          return "Recebido";
        case 2:
          return "Recebido com Ressalva";
        case 3:
          return "Item Recusado";
      }
    },

    formataTipoDispensa(tipo) {
      switch (tipo) {
        case 0:
          return "Comum";
        case 1:
          return "UTI";
        case 2:
          return "Enfermaria";
        case 3:
          return "Centro Cirúrgico";
        case 4:
          return "SADT";
        case 5:
          return "Mandato Judicial";
      }
    },

    formataFamilia(indicador) {
      switch (indicador) {
        case null:
          return "Não vinculado";
        case 0:
          return "Não vinculado";
        case 1:
          return "Medicações";
        case 2:
          return "Materiais";
        case 3:
          return "Psicotrópicos";
        case 4:
          return "Saneantes";
        case 5:
          return "Cosméticos";
        case 6:
          return "Nutrição";
        case 7:
          return "Antimicrobianos";
        case 8:
          return "Amostra Grátis";
        case 9:
          return "Maleta de Emergência";
        case 10:
          return "Doação";
        case 11:
          return "Teste Rápido";
        case 12:
          return "USO INTERNO"
      }
    },

    _formatStringInBrazilianDateFormat(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      } else {
        return "Não informado!";
      }
    },

    corValidade(data) {
      if (data) {
        var ano = data.split("/")[2];
        var mes = data.split("/")[1];
        var dia = data.split("/")[0];
        // var dia2  = dia.substring(0,2)

        const dataFormatada = ano + "-" + ("0" + mes).slice(-2) + "-" + dia;

        const dias = this.verificarDias(dataFormatada);

        if (store.state.numeroEndereco == 127 || store.state.numeroEndereco == "127" || store.state.numeroEndereco == 124 || store.state.numeroEndereco == "124") {
          if (dias > 90) {
            return "green";
          } else if (dias > 0 && dias <= 90) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        } else {
          if (dias > 30) {
            return "green";
          } else if (dias > 0 && dias <= 30) {
            return "orange";
          } else if (dias <= 0) {
            return "red";
          }
        }
      }
    },

    verificarDias(data) {
      const dateAtual = new Date().toISOString().substr(0, 10);
      const daterecive = data;

      const diferenceOfDates = new Date(daterecive) - new Date(dateAtual);
      const daysOfDiference = Math.ceil(diferenceOfDates / (1000 * 60 * 60 * 24));

      return daysOfDiference;
    },

    formatarNome(nomeCompleto) {
      const palavras = nomeCompleto.split(' ');
      let iniciais = '';
      for (const palavra of palavras) {
        const inicial = palavra.charAt(0).toUpperCase();
        iniciais += inicial;
      }

      return iniciais;
    },

    formataCorStatusItemUnidade(status){
      switch (status) {
        case 0:
          return "red";
        case 1:
          return "green";
      }
    },
    
    formataStatusItemUnidade(status){
      switch (status) {
        case 0:
          return "Inativo";
        case 1:
          return "Ativo";
      }
    },

    emitGenerateExcelEvent(row) {
      this.$emit("datatable-excel", row);
    },

    emitMaterialRetiradoEvent(row) {
      this.$emit("datatable-retire", row);
    },

    emitDataTableNewRowEvent() {
      this.$emit("datatable-newrow");
    },

    emitDataTableContextRowEvent(row) {
      this.$emit("datatable-context", row);
    },

    emitDataTableUpdateRowEvent(row) {
      this.$emit("datatable-updaterow", row);
    },

    emitDataTableViewRowEvent(row) {
      this.$emit("datatable-viewrow", row);
    },

    emitDataTableUpdateStatusRowEvent(row) {
      this.$emit("datatable-updatestatusrow", row);
    },

    emitDataTableDeleteRowEvent(row) {
      this.$emit("datatable-deleterow", row);
    },

    emitDataTableDevolucao(row) {
      this.$emit("datatable-devolucao", row);
    },

    emitDataTableDevolucaoProduto(row) {
      this.$emit("datatable-devolucao-produto", row);
    },

    emitDataTableFinishRowEvent(row) {
      this.$emit("datatable-finishrow", row);
    },

    emitDataTablePrintEvent(row) {
      this.$emit("datatable-print", row);
    },

    emitDataTablePrintEventTransferencia(row) {
      this.$emit("datatable-imprimir", row);
    },
  },
};
</script>

<style scoped>
.textovazio {
  color: rgba(0, 0, 0, 0.302);
}
</style>
